/**
 * Maps backend `icon_key` strings → lucide-react icon components.
 * Falls back to `Sparkles` so a new backend key never crashes the UI.
 */
import {
  Scale,
  Sparkles,
  Zap,
  HeartPulse,
  Flame,
  Droplets,
  Pill,
  Brain,
  Flower2,
  Activity,
  Wind,
  Waves,
} from 'lucide-react';

const ICON_MAP = {
  Scale,
  Sparkles,
  Zap,
  HeartPulse,
  Flame,
  Droplets,
  Pill,
  Brain,
  Flower2,
  Activity,
  Wind,
  Waves,
};

export function iconFor(key) {
  return ICON_MAP[key] || Sparkles;
}
